import "./Calculations.scss";

import { useState, useMemo, useEffect } from "react";
import { getTimeFilterObj } from "./calculate";
import { CirclesToRhombusesSpinner } from "react-epic-spinners";
import { useAuth } from "../../../../authentication/authHelpers";
import { calculateEmployeeChart } from "../../../ListPrezenca/timesheet/utils/calculate";
import { useSelector } from "react-redux";

const Calculations = ({ date, viewType }) => {
  const auth = useAuth();
  const { employeeRequests } = useSelector((state) => state.employeeRequests);
  const { clockings } = useSelector((state) => state.clockings);

  const [loadingData, setLoadingData] = useState(true);

  const userData = useMemo(() => {
    if (auth?.employeeId !== null && !!clockings) {
      return clockings.filter((el) => el?.employeeId === auth?.employeeId);
    }
    return [];
  }, [auth?.employeeId, clockings]);

  useEffect(() => {
    if (auth?.employeeId !== null && !!clockings) {
      setLoadingData(false);
    }
  }, [auth?.employeeId, clockings]);

  const timeFilterObj = useMemo(() => {
    if (!date || !viewType)
      return {
        startTime: "",
        endTime: "",
        type: "",
      };
    return getTimeFilterObj(date, viewType);
  }, [date, viewType, userData]);

  const timeCalculated = useMemo(() => {
    const calculations = calculateEmployeeChart(
      userData,
      auth.employeeId,
      {
        start: timeFilterObj.startTime,
        end: timeFilterObj.endTime,
      },
      employeeRequests
    );
    const obj = {
      normalHours: calculations.find((el) => el.key === "normalHours").value,
      lateHours: calculations.find((el) => el.key === "lateHours").value,
      extraHours: calculations.find((el) => el.key === "extraHours").value,
      totalHours: calculations.find((el) => el.key === "totalHours").value,
    };
    return obj;
  }, [
    userData,
    auth?.employeeId,
    timeFilterObj.startTime,
    timeFilterObj.endTime,
    employeeRequests,
  ]);

  //autumn theme
  return (
    <div className="calculations-container">
      <div className="calculation-card" style={{ backgroundColor: "#1da193" }}>
        <span className="category">Para 19:00</span>
        <span className="amount">
          {loadingData ? (
            <CirclesToRhombusesSpinner style={{ marginTop: "15px" }} size={5} />
          ) : (
            timeCalculated?.normalHours.toFixed(2)
          )}
        </span>

        {/* <span className="amount">90.56</span> */}
      </div>
      <div className="calculation-card" style={{ backgroundColor: "#FCC94A" }}>
        <span className="category">19-22:00</span>
        {/* <span className="amount">12.34</span> */}
        <span className="amount">
          {loadingData ? (
            <CirclesToRhombusesSpinner style={{ marginTop: "15px" }} size={5} />
          ) : (
            timeCalculated?.lateHours.toFixed(2)
          )}
        </span>
      </div>
      <div className="calculation-card" style={{ backgroundColor: "#ea3943" }}>
        <span className="category">Pas 22:00</span>
        {/* <span className="amount">16.00</span> */}
        <span className="amount">
          {loadingData ? (
            <CirclesToRhombusesSpinner style={{ marginTop: "15px" }} size={5} />
          ) : (
            timeCalculated?.extraHours.toFixed(2)
          )}
        </span>
      </div>
      <div className="calculation-card" style={{ backgroundColor: "#1d3943" }}>
        <span className="category">Totali</span>
        {/* <span className="amount">86.9</span> */}
        <span className="amount">
          {loadingData ? (
            <CirclesToRhombusesSpinner style={{ marginTop: "15px" }} size={5} />
          ) : (
            timeCalculated?.totalHours.toFixed(2)
          )}
        </span>
      </div>
    </div>
  );
};

export default Calculations;
